<template>
  <div class="home-page">
  <section class="hero">
    <div class="hero__container">
      <div class="hero__copy">
        <h1 class="hero__name">CrysClip</h1>
        <p class="hero__lead">全球首发「CrysClip」智慧饰</p>
        <p class="hero__tagline">是耳机，也是你的隐形闺蜜</p>
        <p class="hero__tags">
          施华洛世奇联名 | AI语音控制 | 珠宝级设计 | 4.9g轻盈佩戴
        </p>
        <div class="hero__collab">
          <span class="hero__collab-main">PAXA x SWAROVSKI</span>
          <span class="hero__collab-sub">联名限定系列</span>
        </div>
        <button type="button" class="hero__cta" @click="goProductCenter">
          探索系列
        </button>
      </div>
      <div class="hero__visual">
        <img
          class="hero__img"
          :src="heroImgUrl"
          alt="CrysClip 产品展示"
        />
      </div>
    </div>
  </section>
  <HomeFooter />
  </div>
</template>

<script>
import heroImg from '@/assets/erji.png'
import HomeFooter from '@/components/HomeFooter.vue'

export default {
  name: 'HomePage',
  components: { HomeFooter },
  data() {
    return {
      /** 首页主视觉：使用 src/assets 下产品图，构建时会走 webpack 资源处理 */
      heroImgUrl: heroImg
    }
  },
  methods: {
    /** 探索系列 → 产品中心 */
    goProductCenter() {
      console.info('[HomePage] 探索系列 → 产品中心')
      this.$router.push({ name: 'product' }).catch((err) => {
        console.error('[HomePage] 跳转产品中心失败:', err)
      })
    }
  }
}
</script>

<style scoped>
.home-page {
  width: 100%;
}

.hero {
  width: 100%;
  box-sizing: border-box;
}

/* 首屏主内容高度 = 视口高 − actionbar__inner（由 ActionBar 写入 --actionbar-inner-height）；自身不出现滚动条，超出由整页滚动 */
.hero__container {
  height: calc(100svh - var(--actionbar-inner-height, 72px));
  max-width: 1440px;
  width: 100%;
  margin: 0 auto;
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.12fr);
  align-items: stretch;
  column-gap: clamp(40px, 5vw, 88px);
  row-gap: 32px;
  padding: clamp(28px, 4vh, 56px) clamp(32px, 4vw, 64px) clamp(20px, 3vh, 48px);
  box-sizing: border-box;
  overflow: visible;
}

.hero__copy {
  max-width: 34rem;
  padding-right: clamp(0px, 2vw, 24px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 0;
}

.hero__name {
  margin: 0 0 clamp(12px, 2vh, 24px);
  font-size: clamp(44px, 5.2vw, 76px);
  font-weight: 700;
  line-height: 1.05;
  letter-spacing: -0.03em;
  color: #000;
  font-family: 'PingFang SC', 'Microsoft YaHei', system-ui, sans-serif;
}

.hero__lead {
  margin: 0 0 10px;
  font-size: clamp(17px, 1.35vw, 22px);
  font-weight: 500;
  line-height: 1.55;
  color: #000;
  font-family: 'PingFang SC', 'Microsoft YaHei', system-ui, sans-serif;
}

.hero__tagline {
  margin: 0 0 clamp(18px, 2.5vh, 28px);
  font-size: clamp(17px, 1.35vw, 22px);
  font-weight: 400;
  line-height: 1.55;
  color: #000;
  font-family: 'PingFang SC', 'Microsoft YaHei', system-ui, sans-serif;
}

.hero__tags {
  margin: 0 0 clamp(22px, 3vh, 36px);
  font-size: clamp(12px, 1vw, 14px);
  line-height: 1.65;
  letter-spacing: 0.02em;
  color: rgba(0, 0, 0, 0.52);
  font-family: 'PingFang SC', 'Microsoft YaHei', system-ui, sans-serif;
}

.hero__collab {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: clamp(24px, 3vh, 40px);
}

.hero__collab-main {
  font-size: clamp(13px, 1.05vw, 15px);
  font-weight: 600;
  letter-spacing: 0.14em;
  color: #000;
  font-family: 'PingFang SC', 'Microsoft YaHei', system-ui, sans-serif;
}

.hero__collab-sub {
  font-size: clamp(11px, 0.9vw, 13px);
  letter-spacing: 0.06em;
  color: rgba(0, 0, 0, 0.48);
  font-family: 'PingFang SC', 'Microsoft YaHei', system-ui, sans-serif;
}

.hero__cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 200px;
  max-width: 100%;
  box-sizing: border-box;
  /* 稿面比例：细边框、偏小胶囊，不要抢主标题视觉 */
  padding: 7px 22px;
  border-radius: 999px;
  border: 1px solid #000;
  background: #fff;
  color: #000;
  font-size: clamp(11px, 0.75vw, 13px);
  font-weight: 400;
  letter-spacing: 0.12em;
  line-height: 1.35;
  cursor: pointer;
  font-family: 'PingFang SC', 'Microsoft YaHei', system-ui, sans-serif;
}

.hero__cta:hover {
  background: #000;
  color: #fff;
}

.hero__visual {
  height: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  min-height: 0;
  box-sizing: border-box;
}

.hero__img {
  width: auto;
  height: auto;
  max-width: min(100%, 620px);
  max-height: 100%;
  object-fit: contain;
  object-position: center right;
  display: block;
  filter: drop-shadow(0 32px 56px rgba(0, 0, 0, 0.14));
}

@media (max-width: 960px) {
  .hero__container {
    grid-template-columns: 1fr;
    padding: 28px 24px 36px;
    align-content: start;
  }

  .hero__copy {
    max-width: none;
    padding-right: 0;
    order: 2;
  }

  .hero__visual {
    order: 1;
    justify-content: center;
  }

  .hero__img {
    max-width: min(92vw, 480px);
    max-height: min(42vh, 420px);
  }
}
</style>
